import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FuseConfigService, Scheme } from '@fuse/services/config';

@Component({
    selector: 'app-theme-toggle',
    imports: [CommonModule],
    templateUrl: './theme-toggle.component.html',
    styleUrl: './theme-toggle.component.html',
})
export class ThemeToggleComponent implements OnInit {
    readonly _fuseConfigService = inject(FuseConfigService);
    config = { scheme: 'auto' as Scheme };

    ngOnInit(): void {
        this._fuseConfigService.config$.subscribe((cfg) => {
            this.config = cfg;
            this.applyTheme(cfg.scheme);
        });
    }

    setScheme(scheme: Scheme): void {
        this._fuseConfigService.config = { scheme };
        this.applyTheme(scheme);
    }
    toggleScheme(): void {
        if (this.config.scheme === 'light') {
            this.setScheme('dark');
        } else {
            this.setScheme('light');
        }
    }

    applyTheme(scheme: Scheme): void {
        const html = document.documentElement;
        html.classList.remove('dark');

        if (scheme === 'dark') {
            html.classList.add('dark');
        } else if (scheme === 'auto') {
            const isDark = window.matchMedia(
                '(prefers-color-scheme: dark)'
            ).matches;
            if (isDark) html.classList.add('dark');
        }
    }
}
